// extracted by mini-css-extract-plugin
export default {"header_video_box":"headerStyles_header_video_box__hf5T9","caption":"headerStyles_caption__UvaYT","btn_header":"headerStyles_btn_header__8HloT"};